/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Argiculture16Inputs */

const en__field_enum_icsrm_argiculture16 = /** @type {(inputs: _Field_Enum_Icsrm_Argiculture16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agricultural, environmental or forest science`)
};

const de__field_enum_icsrm_argiculture16 = /** @type {(inputs: _Field_Enum_Icsrm_Argiculture16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umwelt-, Agrar- & Forstwissenschaften`)
};

/**
* | output |
* | --- |
* | "Agricultural, environmental or forest science" |
*
* @param {_Field_Enum_Icsrm_Argiculture16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_argiculture16 = /** @type {((inputs?: _Field_Enum_Icsrm_Argiculture16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Argiculture16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_argiculture16(inputs)
	return de__field_enum_icsrm_argiculture16(inputs)
});
export { _field_enum_icsrm_argiculture16 as "_field_enum_ICSRM_ARGICULTURE" }